import React from 'react';
import WorkspaceLayout from '../components/WorkspaceLayout';
import WorkspaceCalendarManager from '../components/workspace/WorkspaceCalendarManager';

function WorkCalendarPage() {
  return (
    <WorkspaceLayout
      active="/WorkCalendar"
      title="WorkCalendar"
      description="프로젝트 일정, WBS, 개인 할 일을 같은 흐름에서 확인합니다. 기존 간트 차트와 투두 리스트 기능은 유지하고 전환 구조를 단순화했습니다."
      statusTitle="일정관리 구성"
      metrics={[
        { label: '간트 차트', value: 'WBS' },
        { label: '투두 리스트', value: '일별' },
        { label: '편집 방식', value: 'React' },
      ]}
      toolbarTitle="일정과 할 일"
      toolbarText="간트 차트로 프로젝트 흐름을 보고, 투두 리스트에서 오늘 처리할 항목을 관리합니다."
      badge="내부 UI 교체"
    >
      <WorkspaceCalendarManager />
    </WorkspaceLayout>
  );
}

export default WorkCalendarPage;
